var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 50,
    viewBox: "0 0 52 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2827 5.30211C21.2474 9.33744 20.0552 15.1358 21.6978 20.2176L1.67852 40.2369L1 49L13.009 47.7902V42.1249H18.6742V36.4596H24.3391L31.1402 29.6585C36.2214 31.301 42.0199 30.1088 46.0557 26.0736C51.7917 20.3376 51.7917 11.0376 46.0557 5.30199C40.3197 -0.433998 31.0197 -0.433998 25.2841 5.30199L25.2827 5.30211ZM36.1405 9.55073C37.7048 7.98645 40.241 7.98645 41.8058 9.55073C43.3701 11.115 43.3701 13.6513 41.8058 15.216C40.2415 16.7803 37.7053 16.7803 36.1405 15.216C34.5762 13.6517 34.5762 11.1155 36.1405 9.55073Z",
    stroke: "#585858",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.8bb45dac53755ab2b1169c0622b8d973.svg";
export { ForwardRef as ReactComponent };